'use strict';
define([
    "filebrowser/gdsdata/ShareNode"
], function(ShareNode) {

  function ShareNodeData(response) {
    let parsedResponse = {};
    if (response && response.invitations) {
      parsedResponse = this.parseResponse(response);
    }
    return parsedResponse;
  }

  ShareNodeData.prototype.parseResponse = function(response) {
    if (!response || !response.invitations || !Array.isArray(response.invitations)) {
      throw new TypeError("Invalid arguments");
    }
    let parsedResponse = {};
    let contents = this.parseContents(response.invitations);
    parsedResponse.contents = contents;
    return parsedResponse;
  };

  ShareNodeData.prototype.parseContents = function(invitations) {
    if (!invitations || !Array.isArray(invitations)) {
      throw new TypeError("Invalid arguments");
    }
    let contents = [];
    let len = 0;
    if (invitations && invitations.length > 0) {
      len = invitations.length;
      for (let i = 0; i < len; i++) {
        let folder = new ShareNode(invitations[i]);
        contents.push(folder);
      }
    }
    return contents;
  };

  return ShareNodeData;
});
